import React, { useState, useEffect, useRef } from 'react';
import './BeforeAfterSection.css';
import pinIcon from '../asset/icons/pin.svg';
import sliderIcon from '../asset/icons/slider.svg';
import beforeImg from '../asset/images/restauro-affresco-ghislieri-pavia-prima.webp';
import afterImg from '../asset/images/restauro-affresco-ghislieri-pavia-dopo.webp';

const BeforeAfterSection = () => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [containerWidth, setContainerWidth] = useState(860);
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [containerRef]);

  const handleSliderChange = (e) => {
    setSliderPosition(e.target.value);
  };

  return (
    <section className="before-after-section" id="prima-dopo">
      <svg className="wave-divider-top" viewBox="0 0 1280 100" preserveAspectRatio="none">
        <path d="M0 0H1280V100C1042.88 109.5 470.435 -5.5 0 16V0Z" fill="var(--secondary)"></path>
      </svg>
      
      <div className="container">
        <div className="before-after-header">
          <div className="section-title-decoration">
            <div className="decoration-line"></div>
            <div className="decoration-circle"></div>
            <div className="decoration-line"></div>
          </div>
          <h2 className="section-title">Prima e dopo</h2>
          <p className="section-description">
            Vuoi scoprire l'efficacia del mio lavoro?<br />
            Puoi vederlo con i tuoi occhi, confrontando lo stato iniziale e il risultato finale.
          </p>
        </div>
        
        <div className="before-after-content">
          <div className="project-info">
            <div className="project-badge">
              <img src={pinIcon} alt="Location" className="badge-icon" />
              <span>Pavia</span>
            </div>
            <h3 className="project-info-title">Cupola del Collegio Ghislieri</h3>
            <p className="project-info-type">Restauro architettonico e lapideo</p>
          </div>
          
          <div className="before-after-card" ref={containerRef}>
            <div className="before-after-image">
              <div 
                className="after-image" 
                style={{ backgroundImage: `url(${afterImg})` }}
              ></div>
              <div 
                className="before-image" 
                style={{ width: `${sliderPosition}%` }}
              >
                <div 
                  className="before-image-inner" 
                  style={{ 
                    backgroundImage: `url(${beforeImg})`,
                    width: containerWidth
                  }}
                ></div>
              </div>
              
              <div 
                className="slider-line" 
                style={{ left: `${sliderPosition}%` }}
              ></div>
              
              <div className="slider-container">
                <input 
                  type="range" 
                  min="0" 
                  max="100" 
                  value={sliderPosition} 
                  onChange={handleSliderChange} 
                  className="slider"
                  aria-label="Posizione del cursore Prima/Dopo"
                />
                <div className="slider-button" style={{ left: `calc(${sliderPosition}% + 1px)` }}>
                  <img src={sliderIcon} alt="Slider" className="slider-icon" />
                </div>
              </div>
              
              <div className="image-labels">
                <div className="image-label before-label">Prima</div>
                <div className="image-label after-label">Dopo</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection; 